<template>
    <div class="row wrapper border-bottom white-bg page-heading">
        <div class="col-lg-12 align-self-center go-back d-flex justify-content-between">
            <h2 class="mt-0 text-mute">{{ $t('navigations.risk summary') }}</h2>
            <h2 class="mt-0"> <router-link to="/studymonitoring" class="nav-link p-0 text-primary">Back</router-link></h2>
        </div>
    </div>
    <div class="wrapper wrapper-content animated fadeInRight px-0">
        <div class="container-fluid h-100">
            <div class="row g-0 h-100">
                <!-- Left Tree Panel -->
                <div class="col-md-4 p-1">
                    <div class="mb-4">
                        <div class="ibox-title bg-light d-flex justify-content-between py-1">
                            <h5 class="mt-2">{{ $t("navigations.kris") }}</h5>
                            <select v-model="selectedSiteId" class="form-select py-1 w-50" aria-label="Filter by owner" data-v-e6cceab2="">
                                <option value="">{{ $t("navigations.select site") }}</option>
                                        <option
                                            v-for="site in sites"
                                            :key="site.siteID"
                                            :value="site.siteID"
                                            >
                                            {{ site.siteCode }}
                                        </option>
                            </select>
                        </div>
                        <div class="ibox-content p-3 h-100 d-flex flex-column">

                            <!-- Tree Structure -->
                            <!-- contents here -->
                            <rbqmNavbar :selectedsite="selectedSiteId" @sub-category-click="onSubCategorySelected"></rbqmNavbar>
                        </div>
                    </div>
                </div>

                <!-- Right Content Area -->
                <div class="col-md-8 p-1 h-100 d-flex flex-column">
                    <div class="ibox-title bg-light d-flex justify-content-between">
                        <h5>{{ $t("navigations.riskindicator") }}</h5>
                    </div>
                    <div class="ibox-content">
                    <div class="wrap">
                        <div class="rbqm-table" role="rbqm-table" aria-label="Risk Assessment rbqm-table">
                            <!-- header -->
                            <div class="rbqm-thead" role="row">
                                <div class="cell text-center" role="columnheader">Category ID</div>
                                <div class="cell" role="columnheader">Risk Indicator</div>
                                <div class="cell text-center" role="columnheader">Score</div>
                                <div class="cell text-center" role="columnheader">Impact</div>
                                <div class="cell text-center" role="columnheader">Probability</div>
                                <div class="cell text-center" role="columnheader">Detectability</div>
                                <div class="cell text-center" role="columnheader">View</div>
                            </div>

                            <!-- placeholder when nothing selected -->
                            <div v-if="!selectedRows.length" class="rbqm-row" role="row">
                                <div class="cell" role="cell" style="grid-column: 1 / -1; color:#6b7280; padding:10px">
                                    Select a subcategory on the left to see its risks here.
                                </div>
                            </div>

                            <!-- dynamic rows -->
                            <div v-else class="rbqm-row" v-for="row in selectedRows" :key="row.key" role="row">
                                <div class="cell text-center" role="cell">
                                    <span class="index">{{ row.orderNo }}</span>
                                </div>

                                <div class="cell" role="cell">{{ row.riskIndicator }}</div>

                                <div class="cell text-center" role="cell">
                                    <span class="score" :style="{ backgroundColor: row.color }">{{ row.score }}</span>
                                </div>
                                <!-- Impact -->
                                <div class="cell text-center" role="cell">
                                    <span class="meter" :aria-label="`Impact score ${row.impact} of 3`">
                                        <span class="seg" :class="{ filled: row.impact >= 1 }"
                                            :style="row.impact >= 1 ? { backgroundColor: row.color } : null"></span>
                                        <span class="seg" :class="{ filled: row.impact >= 2 }"
                                            :style="row.impact >= 2 ? { backgroundColor: row.color } : null"></span>
                                        <span class="seg" :class="{ filled: row.impact >= 3 }"
                                            :style="row.impact >= 3 ? { backgroundColor: row.color } : null"></span>
                                    </span>
                                </div>

                                <!-- Probability -->
                                <div class="cell text-center" role="cell">
                                    <span class="meter" :aria-label="`Probability score ${row.probability} of 3`">
                                        <span class="seg" :class="{ filled: row.probability >= 1 }"
                                            :style="row.probability >= 1 ? { backgroundColor: row.color } : null"></span>
                                        <span class="seg" :class="{ filled: row.probability >= 2 }"
                                            :style="row.probability >= 2 ? { backgroundColor: row.color } : null"></span>
                                        <span class="seg" :class="{ filled: row.probability >= 3 }"
                                            :style="row.probability >= 3 ? { backgroundColor: row.color } : null"></span>
                                    </span>
                                </div>

                                <!-- Detectability -->
                                <div class="cell text-center" role="cell">
                                    <span class="meter" :aria-label="`Detectability score ${row.detectability} of 3`">
                                        <span class="seg" :class="{ filled: row.detectability >= 1 }"
                                            :style="row.detectability >= 1 ? { backgroundColor: row.color } : null"></span>
                                        <span class="seg" :class="{ filled: row.detectability >= 2 }"
                                            :style="row.detectability >= 2 ? { backgroundColor: row.color } : null"></span>
                                        <span class="seg" :class="{ filled: row.detectability >= 3 }"
                                            :style="row.detectability >= 3 ? { backgroundColor: row.color } : null"></span>
                                    </span>
                                </div>
                                <div class="cell text-center" role="cell">
                                    <i class="fa fa-eye edit-delete" @click="openModal(row.id)"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <customModal v-if="showModal" :containerxxl=true :bodyxl = true :footerShow = true @closeModal="closeModal">
    <template #title>
       <h4 class="my-0">Risk Assessment Details</h4>
    </template>
    <template #body>
          <form>
                    <div class="d-flex justify-content-end">
                        <button v-if="riskDetails.isFlagged == false" type="submit" class="cancel_btn py-0 px-2 mb-2"  @click.prevent="CreateRiskClicked(riskDetails.riskScoreId)"> Add Risk Register </button>
                        <button v-if="riskDetails.isFlagged == true"  type="submit" class="cancel_btn py-0 px-2 mb-2"  @click.prevent="CreateRiskClicked(riskDetails.riskScoreId )"> View Risk Register </button>
                    </div>
                    <!-- Basic Information -->
                    <div class="ibox-title bg-light">
                        <h5 class="mb-0">Basic Information</h5>
                    </div>
                    <div class="ibox-content mb-2">
                        <div class="form-row">
                            <div class="col-md-6">
                                <div class="form-group mb-1 d-flex align-items-center">
                                    <label class="mb-0 text-primary"><strong>Risk Name:</strong></label>
                                    <p class="px-2 mb-0">{{ riskDetails.riskName }}</p>
                                </div>
                                <div class="form-group mb-1 d-flex align-items-center">
                                    <label class="mb-0 text-primary"><strong>Category:</strong></label>
                                    <p class="px-2 mb-0">{{ riskDetails.category }}</p>
                                </div>
                                <div class="form-group mb-1 d-flex align-items-center">
                                    <label class="mb-0 text-primary"><strong>Sub Category:</strong></label>
                                    <p class="px-2 mb-0">{{ riskDetails.subCategory }}</p>
                                </div>
                                <div class="form-group mb-1 d-flex align-items-center">
                                    <label class="mb-0 text-primary"><strong>Risk Indicator:</strong></label>
                                    <p class="px-2 mb-0">{{ riskDetails.riskIndicator }}</p>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group mb-1 d-flex align-items-center">
                                    <label class="mb-0 text-primary"><strong>Core or Extended KRI:</strong></label>
                                    <p class="px-2 mb-0">{{ riskDetails.coreOrExtendedKRI || 'Not specified' }}</p>
                                </div>
                                <div class="form-group mb-1 d-flex align-items-center">
                                    <label class="mb-0 text-primary"><strong>General or Specific:</strong></label>
                                    <p class="px-2 mb-0">{{ riskDetails.generalOrSpecific }}</p>
                                </div>
                                <div class="form-group mb-1 d-flex align-items-center">
                                    <label class="mb-0 text-primary"><strong>Level of Scrutiny:</strong></label>
                                    <p class="px-2 mb-0">{{ riskDetails.levelOfScrutiny }}</p>
                                </div>
                                <div class="form-group mb-1 d-flex align-items-center">
                                    <label class="mb-0 text-primary"><strong>Phase</strong></label>
                                    <p class="px-2 mb-0">{{ riskDetails.phase }}</p>
                                </div>
                            </div>
                            <div class="col-md-12 mt-2">
                                <div class="form-group mb-1 d-flex align-items-center ibox-content bg-light p-1">
                                    <label class="mb-0 text-primary"><strong>Discussion Details: </strong></label>
                                    <p class="px-2 mb-0">{{ riskDetails.discussionDetails }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="ibox-content my-2">
                        <div class="form-row p-1">
                            <div class="form-group mb-0 col-md-2 d-flex gap-2">
                                <label class="mb-0"><strong>{{ $t('navigations.value') }}:</strong></label>
                                <h4 class="py-0 my-0 text-info">{{ riskDetails.value }}</h4>
                            </div>
                            <div class="form-group mb-0 col-md-10 d-flex gap-2">
                                <label class="mb-0"><strong>{{ $t('navigations.unit') }}:</strong></label>
                                <h4 class="py-0 my-0 text-info">{{ riskDetails.unit }}</h4>
                            </div>
                            <div class="col-12">
                                  <hr>
                            </div>
                      
                            <div class="form-group mb-0 col-md-2 d-flex gap-2">
                                <label class="mb-0"><strong>Probability:</strong></label>
                                <h4 class="py-0 my-0 text-info">{{ riskDetails.probability }}</h4>
                            </div>
                            <div class="form-group mb-0 col-md-2 d-flex gap-2">
                                <label class="mb-0"><strong>Impact:</strong></label>
                                <h4 class="py-0 my-0 text-danger">{{ riskDetails.impact }}</h4>
                            </div>
                            <div class="form-group mb-0 col-md-2 d-flex gap-2">
                                <label class="mb-0"><strong>Detectability:</strong></label>
                                <h4 class="py-0 my-0 text-warning">{{ riskDetails.detectability }}</h4>
                            </div>
                            <div class="form-group mb-0 col-md-2 d-flex gap-2">
                                <label class="mb-0"><strong>Score:</strong></label>
                                <h4 class="py-0 my-0 text-warning">{{ riskDetails.score }}</h4>
                            </div>
                            <div class="form-group mb-0 col-md-4 d-flex gap-2">
                                <label class="mb-0"><strong>Risk Level:</strong></label>
                                <span class="badge" :style="{ backgroundColor: riskDetails.riskLevelColor, color: '#000' }">{{ riskDetails.riskLevelLabel }}</span>
                            </div>
                        </div>
                    </div>
                 
                    <!-- Additional Information -->
                    <!-- <div class="ibox-title bg-light">
                        <h5 class="mb-0">Additional Information</h5>
                    </div>
                    <div class="ibox-content mb-2">
                        <div class="form-row">
                            <div class="form-group col-md-4 mb-0">
                                <label class="mb-0"><strong>Examples for High/Medium/Low Risk</strong></label>
                                <textarea class="custom-textarea" rows="1" v-model="riskDetails.examplesforHighMediumLowRisk"></textarea>
                            </div>
                            <div class="form-group col-md-4 mb-0">
                                <label class="mb-0"><strong>Functional Plan Impacted</strong></label>
                                <textarea class="custom-textarea" rows="1" v-model="riskDetails.functionalPlanImpacted"></textarea>
                            </div>
                            <div class="form-group col-md-4 mb-0">
                                <label class="mb-0"><strong>Rationale for Risk Level</strong></label>
                                <textarea class="custom-textarea" rows="1" v-model="riskDetails.rationaleForRiskLevel"></textarea>
                            </div>
                        </div>
                    </div>
                    <hr> -->
                    <!-- Metadata -->
                    <div class="ibox-title bg-light">
                        <h5 class="mb-0">Metadata</h5>
                    </div>
                    <div class="ibox-content mb-2">
                        <div class="form-row">
                            <div class="form-group col-md-6 ibox-content mb-0">
                                <div class="form-group mb-2 d-flex align-items-center">
                                    <label class="mb-0 text-primary"><strong>Created at :</strong></label>
                                    <p class="px-2 mb-0">{{ riskDetails.createdAt }}</p>
                                </div>
                                <div class="form-group mb-2 d-flex align-items-center">
                                    <label class="mb-0 text-primary"><strong>Created by :</strong></label>
                                    <p class="px-2 mb-0">{{ riskDetails.createdUserEmail }}</p>
                                </div>
                            </div>
                            <div class="form-group col-md-6 ibox-content mb-0">
                                <div class="form-group mb-2 d-flex align-items-center">
                                    <label class="mb-0 text-primary"><strong>Last modified at :</strong></label>
                                    <p class="px-2 mb-0">{{ riskDetails.lastModifiedAt }}</p>
                                </div>
                                <div class="form-group mb-2 d-flex align-items-center">
                                    <label class="mb-0 text-primary"><strong>Last modified by :</strong></label>
                                    <p class="px-2 mb-0">{{ riskDetails.lastModifiedUserEmail }}</p>
                                </div>
                            </div>
                            <!-- <div class="form-group col-md-6 ibox-content">
                                <div class="form-group mb-2 d-flex align-items-center">
                                    <label class="mb-0 text-primary"><strong>Study ID:</strong></label>
                                    <p class="px-2 mb-0">{{ riskDetails.studyId }}</p>
                                </div>
                                <div class="form-group mb-2 d-flex align-items-center">
                                    <label class="mb-0 text-primary"><strong>Account ID:</strong></label>
                                    <p class="px-2 mb-0">{{ riskDetails.accountId }}</p>
                                </div>
                                <div class="form-group mb-2 d-flex align-items-center">
                                    <label class="mb-0 text-primary"><strong>Risk Score ID</strong></label>
                                    <p class="px-2 mb-0">{{ riskDetails.riskScoreId }}</p>
                                </div>
                                <div class="form-group mb-2 d-flex align-items-center">
                                    <label class="mb-0 text-primary"><strong>Risk Indicator Item ID</strong></label>
                                    <p class="px-2 mb-0">{{ riskDetails.riskIndicatorItemId }}</p>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </form>
    </template>
    <template #footer>
        <div class="d-flex justify-content-end">
                <button type="submit" class="btn btn-sm btn-outline-primary py-1"  @click="updateRiskScore(modalData.id)">Save Changes</button>
            </div>
    </template>
  </customModal>
  <manageRiskRegisterModal 
    v-if="showRiskRegisterModal"
    :riskRegId="riskRegisterId"
    @closeModal="closeRiskReg"
  />



</template>
<script src="./rbqm_dashboard.js"></script>
<style scoped>
.custom-textarea,.custom-textarea:focus-visible{
    border: 1px solid rgb(239, 239, 239);
}
.summary-tile {
    border-radius: 8px;
    transition: all 0.3s ease;
}

.summary-tile:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.summary-tile h2 {
    font-weight: 600 !important;
}

.chart-container {
    position: relative;
    height: 250px;
}

.status-dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    display: inline-block;
}

.dot-green {
    background-color: #28a745;
}

.dot-yellow {
    background-color: #ffc107;
}

.dot-red {
    background-color: #dc3545;
}

.dot-gray {
    background-color: #6c757d;
}

.kri-table th {
    position: sticky;
    top: 0;
    background: white;
    z-index: 10;
}

.sidebar-brand {
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    color: #0d6efd;
    background-color: rgba(13, 110, 253, 0.1);
    border-bottom: 1px solid #dee2e6;
}

.sidebar-toggle {
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;
}

.critical-process-dashboard {
    padding: 0rem 1rem 1rem 1rem;
    max-width: 1800px;
    margin: 0 auto;
    position: relative;
}

.dashboard-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 1rem;
    padding: 1rem 0rem 0rem 0rem;
}

.search-filter-container {
    display: flex;
    flex-grow: 1;
    gap: 1rem;
    flex-wrap: wrap;
}

.search-bar {
    flex: 1;
    position: relative;
}

.search-bar i {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #6c757d;
}

.search-bar input {
    width: 100%;
    padding: 0rem 1rem 0rem 2.5rem;
    border: 1px solid #dee2e6;
    border-radius: 1px;
    font-size: .75rem;
}

.filter-controls {
    display: flex;
    flex-wrap: wrap;
}

.form-select {
    padding: 0.75rem 1rem;
    border-radius: 8px;
    min-width: 180px;
    border: 1px solid #dee2e6;
}

.add-process-btn {
    padding: 0.75rem 1.5rem;
    border-radius: 8px;
    font-weight: 500;
    white-space: nowrap;
}

.process-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
    gap: 1.5rem;
    margin-top: 1rem;
}

.process-card {
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    border: 1px solid #e9ecef;
    display: flex;
    flex-direction: column;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.process-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.card-header {
    padding: .25rem 1rem;
    border-bottom: 1px solid #f1f3f5;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.priority-badge {
    padding: 0.25rem 0.75rem;
    border-radius: 50px;
    font-size: 0.75rem;
    font-weight: 600;
}

.high-priority .priority-badge {
    background-color: #fff0f0;
    color: #dc3545;
}

.medium-priority .priority-badge {
    background-color: #fff8e6;
    color: #fd7e14;
}

.low-priority .priority-badge {
    background-color: #f0f9ff;
    color: #0d6efd;
}

.card-actions {
    display: flex;
    gap: 0.2rem;
}


.btn-icon {
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: transparent;
    border: none;
    color: #6c757d;
    transition: background 0.2s ease;
}

.btn-icon:hover {
    background: #f8f9fa;
    color: #495057;
    transform: translateY(-3px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.card-body {
    padding: 1.25rem;
    flex-grow: 1;
}

.process-title {
    font-size: 1.25rem;
    font-weight: 600;
    margin-bottom: 0.75rem;
    color: #212529;
}

.process-description {
    color: #6c757d;
    margin-bottom: 1.5rem;
    line-height: 1.5;
}

.process-meta {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.data-counter {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.875rem;
    color: #495057;
    background: #f8f9fa;
    padding: 0.375rem 0.75rem;
    border-radius: 50px;
}

.process-owner {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    font-size: 0.875rem;
}

.avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: #e9ecef;
    color: #495057;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    font-size: 0.75rem;
}

.form-switch {
    padding-left: 3rem;
}

.form-switch .form-check-input {
    width: 2.5rem;
    height: 1.5rem;
    margin-left: -3rem;
}

.fab {
    position: fixed;
    bottom: 2rem;
    right: 2rem;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 1000;
}

@media (max-width: 768px) {
    .process-grid {
        grid-template-columns: 1fr;
    }

    .search-filter-container {
        flex-direction: column;
    }

    .search-bar {
        min-width: 100%;
    }
}

.rbqm-table {
    width: 100%;
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 6px 18px rgba(16, 24, 40, .06);
}

.rbqm-thead,
.rbqm-row {
    display: grid;
    grid-template-columns: 100px 1fr 50px 110px 110px 110px 50px;
    align-items: center;
}

.rbqm-thead {
    background: #fbfcfe;
    color: var(--muted);
    font-weight: 600;
    letter-spacing: .2px;
    border-bottom: 1px solid #e5e7eb;
    padding: 6px 0px;
}

.cell {
    padding: 4px 4px
}

/* left index pill */
.index {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 6px;
    background: #2f6fb5;
    color: #fff;
    font-weight: 600;
}

/* score bubble */
.score {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 999px;
    color: #fff;
    font-weight: 700
}

.score.green {
    background: #1fa55b;
}

.score.amber {
    background: #f1b52a;
}

.score.red {
    background: #e24b4b;
}

/* segmented meter */
.meter {
    display: inline-grid;
    grid-auto-flow: column;
    gap: 6px
}

.seg {
    width: 22px;
    height: 8px;
    border-radius: 4px;
    background: #e9edf3;
    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, .04)
}

.seg.filled.green {
    background: #1fa55b;
}

.seg.filled.amber {
    background: #f1b52a;
}

.seg.filled.red {
    background: #e24b4b;
}

.rbqm-row {
    border-top: 1px solid #e5e7eb
}
.modal-body {
    max-height: 500px; /* Adjust height as needed */
    overflow-y: auto;
}

/* responsive */
@media (max-width:900px) {

    .rbqm-thead,
    .row {
        grid-template-columns: 64px 1fr 82px 1fr
    }

    .rbqm-thead .cell:nth-child(n+5),
    .row .cell:nth-child(n+5) {
        display: none
    }

    .rbqm-thead .cell:nth-child(4)::after {
        content: "  • Impact / Prob. / Detect.";
        color: var(--muted);
        font-weight: 500
    }

    .stacked-meters {
        display: flex;
        gap: 16px;
        align-items: center
    }

    .label {
        display: none
    }
}

.label {
    font-size: 12px;
    color: var(--muted);
    margin-right: 8px
}
</style>